import * as types from './mutation_types'

export const fetchPlaylists = ({ commit }, payload) => {
  commit(types.SET_PLAYLISTS, payload)
}
